import type {BulkUpdate, DataLoadStatus} from 'api';
import { useGetResource} from 'api';
import {getBulkUpdate} from 'api/bulkUpdate';
import {useGetTokens} from 'services/auth';

export const useBulkUpdate = (id: string): DataLoadStatus<BulkUpdate> => {
  const mock = false;
  const getTokens = useGetTokens();
  return useGetResource(() => getBulkUpdate(id, getTokens, mock));
};
